/**
 * SandboxRunCodeDisplay - web用スタイリングラッパー
 *
 * @kyumo/shared-ui の SandboxRunCodeDisplay にweb固有のスタイルを適用。
 */

import type { ContainerExecutionResult, SandboxRunCodeDisplayClassNames } from '@kyumo/shared-ui';
import { SandboxRunCodeDisplay as SharedSandboxRunCodeDisplay } from '@kyumo/shared-ui';

export interface SandboxRunCodeDisplayProps {
  /** ツール呼び出し引数 */
  args: unknown;
  /** ツール実行結果（存在する場合） */
  result: unknown;
  /** 追加の CSS クラス */
  className?: string;
}

interface SandboxRunCodeArgs {
  runtime: 'python' | 'node';
  code: string;
  timeoutMs?: number;
}

const webClassNames: SandboxRunCodeDisplayClassNames = {
  triggerButton: 'hover:bg-muted/50',
  chevron: 'text-muted-foreground',
  codeLabel: 'text-muted-foreground',
  codeLabelValue: 'bg-muted text-foreground',
  resultLabel: 'text-muted-foreground',
  resultSuccess: 'text-green-400',
  resultFail: 'text-red-400',
  sectionWrapper: 'px-2 pb-2',
  codeBlock: {
    root: 'bg-muted',
    header: 'border-border',
    headerLabel: 'text-muted-foreground',
    pre: 'text-foreground',
    copyButton: 'text-muted-foreground hover:bg-accent hover:text-foreground',
  },
  executionOutput: {
    timeoutAlert: 'bg-muted border border-amber-600/50 text-amber-400',
    emptyOutput: 'text-muted-foreground',
    section: 'bg-muted border border-border',
    sectionHeader: 'border-border',
    labelSuccess: 'text-green-400',
    labelError: 'text-red-400',
    labelDefault: 'text-muted-foreground',
    pre: 'text-foreground',
    copyButton: 'text-muted-foreground hover:bg-accent hover:text-foreground',
  },
};

export function SandboxRunCodeDisplay({ args, result, className }: SandboxRunCodeDisplayProps) {
  const typedArgs = args as SandboxRunCodeArgs;
  const executionResult = result as ContainerExecutionResult | undefined;

  return (
    <SharedSandboxRunCodeDisplay
      runtime={typedArgs.runtime}
      code={typedArgs.code}
      result={executionResult}
      className={className}
      classNames={webClassNames}
    />
  );
}
